module.exports = __webpack_public_path__ + "static/img/logo.dff06253.png";